export const BrandColors = {
    // Primary / blue brand scale — matches --blue-* in emptheme.scss
    primary: {
        50:  '#EFF1FD',
        100: '#CDD4FA',
        200: '#B5BFF7',
        300: '#94A2F4',
        400: '#7F90F1',
        500: '#5F74EE', // Main brand color
        600: '#566AD9',
        700: '#4352A9',
        800: '#344083',
        900: '#283164',
        950: '#172554',
    },

    // Surface scale — matches --surface-* in emptheme.scss
    surface: {
        0:   '#ffffff',
        50:  '#F9FBFD',
        100: '#ECF1F9',
        200: '#B1BFD7',
        300: '#cbd5e1',
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a',
        950: '#020617',
    },

    // Gray scale — matches --gray-* in emptheme.scss
    gray: {
        0:   '#ffffff',
        50:  '#F9FBFD',
        100: '#ECF1F9',
        200: '#E3EAF6',
        300: '#D6E1F2',
        400: '#CEDBF0',
        500: '#C2D2EC',
        600: '#B1BFD7',
        700: '#8A95A8',
        800: '#6B7482',
        900: '#515863',
        950: '#020617',
    },

    // Red / danger scale — matches --red-* in emptheme.scss
    red: {
        50:  '#FEF0EF',
        100: '#FBCFCC',
        200: '#F9B8B3',
        300: '#F79790',
        400: '#F5837B',
        500: '#F3645A',
        600: '#DD5B52',
        700: '#AD4740',
        800: '#863732',
        900: '#662A26',
    },

    // Green / success scale — matches --green-* in emptheme.scss
    green: {
        50:  '#f4fcf7',
        100: '#caf1d8',
        200: '#a0e6ba',
        300: '#8CDE9A',
        400: '#4cd07d',
        500: '#54CD68',
        600: '#1da750',
        700: '#3C924A',
        800: '#136c34',
        900: '#0e4f26',
    },

    // Yellow / warning scale — matches --yellow-* in emptheme.scss
    yellow: {
        50:  '#fefbf3',
        100: '#faedc4',
        200: '#f6de95',
        300: '#f2d066',
        400: '#eec137',
        500: '#eab308',
        600: '#c79807',
        700: '#a47d06',
        800: '#816204',
        900: '#5e4803',
    },

    // Orange scale — matches --orange-* in emptheme.scss
    orange: {
        50:  '#fff8f3',
        100: '#feddc7',
        200: '#fcc39b',
        300: '#fba86f',
        400: '#fa8e42',
        500: '#FF9A64',
        600: '#d46213',
        700: '#ae510f',
        800: '#893f0c',
        900: '#642e09',
    },

    // Cyan / info scale — matches --cyan-* in emptheme.scss
    cyan: {
        50:  '#f3fbfd',
        100: '#c3edf5',
        200: '#94e0ed',
        300: '#65d2e4',
        400: '#35c4dc',
        500: '#06b6d4',
        600: '#059bb4',
        700: '#047f94',
        800: '#036475',
        900: '#024955',
    },

    // Teal scale — matches --teal-* in emptheme.scss
    teal: {
        50:  '#f3fbfb',
        100: '#c7eeea',
        200: '#9ae0d9',
        300: '#6dd3c8',
        400: '#41c5b7',
        500: '#14b8a6',
        600: '#119c8d',
        700: '#0e8174',
        800: '#0b655b',
        900: '#084a42',
    },

    // Lavender scale — matches --lavender-* in emptheme.scss
    lavender: {
        50:  '#F6F3FF',
        200: '#D7C8FF',
        400: '#BA9FFF',
        500: '#A987FF',
        600: '#9A7BE8',
        800: '#5D4A8C',
        900: '#47396B',
    },

    // Indigo scale — matches --indigo-* in emptheme.scss
    indigo: {
        50:  '#F6F3FF',
        100: '#E4DAFF',
        200: '#bcbdf9',
        300: '#9ea0f6',
        400: '#8183f4',
        500: '#6366f1',
        600: '#5457cd',
        700: '#4547a9',
        800: '#363885',
        900: '#282960',
    },

    // Pink scale — matches --pink-* in emptheme.scss
    pink: {
        50:  '#fef6fa',
        100: '#fad3e7',
        200: '#f7b0d3',
        300: '#f38ec0',
        400: '#f06bac',
        500: '#ec4899',
        600: '#c93d82',
        700: '#a5326b',
        800: '#822854',
        900: '#5e1d3d',
    },

    // Semantic convenience aliases
    semantic: {
        text:           '#000000',
        textSecondary:  '#64748b',
        textInverse:    '#ffffff',
        border:         '#B1BFD7',
        borderHover:    '#7F90F1',
        background:     '#F9FBFD',
        backgroundCard: '#ffffff',
        overlay:        '#ffffff',
        hover:          '#ECF1F9',
        highlight:      '#EFF1FD',
        highlightText:  '#283164',
        focusRing:      '#B5BFF7',
        mask:           'rgba(0, 0, 0, 0.4)',
    },
};